import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  convivente,
  death,
  others,
  parents,
  specialChild,
  spouses,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const RCMADocs = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCertidaoCasamento: dynamicRule('casamento'),
    anexoCertidaoNascimento: dynamicRule('nascimento'),
    anexoLaudoMedico: dynamicRule('laudoMedico'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),
    anexoOutros: dynamicRule(),
  };
  const docs = {
    commons: [...commons, ...death],
    others: [...others],
    [constants.PAI]: parents,
    [constants.MAE]: parents,
    [constants.CONJUGE]: spouses,
    [constants.EX_CONJUGE]: spouses,
    [constants.FILHO]: childs,
    [constants.FILHO_ESPECIAL]: [...childs, ...specialChild],
    [constants.CONVIVENTE]: [...convivente, ...casoUniaoEstavel],
    [constants.ENTEADO]: [...childs, ...certidaoGenitor],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
